import CreateCategory from "@/app/shared/ecommerce/category/create-category";
import PageHeader from "@/app/shared/page-header";
import { Button } from "rizzui";
import routes from "@/routers/routes";
import { Link } from "react-router-dom";
import { metaObject } from "@/config/site.config";

export const metadata = {
  ...metaObject("Create a Category"),
};

const pageHeader = {
  title: "Create A Category",
  breadcrumb: [
    {
      href: routes.eCommerce.dashboard,
      name: "E-Commerce",
    },
    {
      href: routes.eCommerce.categories,
      name: "Categories",
    },
    {
      name: "Create",
    },
  ],
};

export default function CreateCategoryPage() {
  return (
    <>
      <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
        <Link
          to={routes.eCommerce.categories}
          className="mt-4 w-full @lg:mt-0 @lg:w-auto"
        >
          <Button as="span" className="w-full @lg:w-auto" variant="outline">
            Cancel
          </Button>
        </Link>
      </PageHeader>
      <CreateCategory />
    </>
  );
}
